import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'
import {
  ETenderPaymentSummaryStatus,
  ITendersControlPanelSummary,
} from 'types/tender'

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

type Props = {
  controlPanelSummary: ITendersControlPanelSummary
}

export const PaymentSummaryTable = ({ controlPanelSummary }: Props) => {
  const { t } = useTranslation()
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <StyledTable size="small" sx={{ minWidth: 650, borderCollapse: 'collapse' }}>
          <TableHead>
            <TableRow>
              <TableCell>{t('supplier-name')}</TableCell>
              <TableCell>{t('contest-fee')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {controlPanelSummary.tenderPaymentSummaryList.map((pay, index) => (
              <TableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell scope="row">{pay.organizationName}</TableCell>
                <TableCell scope="row">
                  {pay.paymentStatus !== ETenderPaymentSummaryStatus.AUTHORIZED
                    ? t('not-paid')
                    : formatTimeStampToDate(pay.paymentDate)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </Paper>
  )
}
